module.exports = __webpack_public_path__ + "static/media/santander.18280e1f.webp";